// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * a11y-light theme for JavaScript, CSS, and HTML
 * Based on the okaidia theme: https://github.com/PrismJS/prism/blob/gh-pages/themes/prism-okaidia.css
 * @author ericwbailey
 */

.codeblock-light code[class*="language-"],
.codeblock-light pre[class*="language-"] {
	color: #545454;
	background: #fbfbfb;
	font-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;
	text-align: left;
	white-space: pre;
	word-spacing: normal;
	word-break: normal;
	word-wrap: normal;
	line-height: 1.65em;

	-moz-tab-size: 4;
	-o-tab-size: 4;
	tab-size: 4;

	-webkit-hyphens: none;
	-moz-hyphens: none;
	-ms-hyphens: none;
	hyphens: none;
}

/* Code blocks */
.codeblock-light pre[class*="language-"] {
	padding: 1em;
	margin: 0;
	overflow: auto;
	border-radius: 0.3em;
}

.codeblock-light :not(pre) > code[class*="language-"],
.codeblock-light pre[class*="language-"] {
	background: #fbfbfb;
}

/* Inline code */
.codeblock-light :not(pre) > code[class*="language-"] {
	padding: 0.1em;
	border-radius: 0.3em;
	white-space: normal;
}

.codeblock-light .token.comment,
.codeblock-light .token.prolog,
.codeblock-light .token.doctype,
.codeblock-light .token.cdata {
	color: #696969;
}

.codeblock-light .token.punctuation {
	color: #545454;
}

.codeblock-light .token.property,
.codeblock-light .token.tag,
.codeblock-light .token.constant,
.codeblock-light .token.symbol,
.codeblock-light .token.deleted {
	color: #007faa;
}

.codeblock-light .token.boolean,
.codeblock-light .token.number {
	color: #008000;
}

.codeblock-light .token.selector,
.codeblock-light .token.attr-name,
.codeblock-light .token.string,
.codeblock-light .token.char,
.codeblock-light .token.builtin,
.codeblock-light .token.inserted {
	color: #aa5d00;
}

.codeblock-light .token.operator,
.codeblock-light .token.entity,
.codeblock-light .token.url,
.codeblock-light .language-css .token.string,
.codeblock-light .style .token.string,
.codeblock-light .token.variable {
	color: #008000;
}

.codeblock-light .token.atrule,
.codeblock-light .token.attr-value,
.codeblock-light .token.function {
	color: #aa5d00;
}

.codeblock-light .token.keyword {
	color: #d91e18;
}

.codeblock-light .token.regex,
.codeblock-light .token.important {
	color: #d91e18;
}

.codeblock-light .token.important,
.codeblock-light .token.bold {
	font-weight: bold;
}
.codeblock-light .token.italic {
	font-style: italic;
}

.codeblock-light .token.entity {
	cursor: help;
}

@media screen and (-ms-high-contrast: active) {
	.codeblock-light code[class*="language-"],
	.codeblock-light pre[class*="language-"] {
		color: windowText;
		background: window;
	}

	.codeblock-light :not(pre) > code[class*="language-"],
	.codeblock-light pre[class*="language-"] {
		background: window;
	}

	.codeblock-light .token.important {
		background: highlight;
		color: window;
		font-weight: normal;
	}

	.codeblock-light .token.atrule,
	.codeblock-light .token.attr-value,
	.codeblock-light .token.function,
	.codeblock-light .token.keyword,
	.codeblock-light .token.operator,
	.codeblock-light .token.selector {
		font-weight: bold;
	}

	.codeblock-light .token.attr-value,
	.codeblock-light .token.comment,
	.codeblock-light .token.doctype,
	.codeblock-light .token.function,
	.codeblock-light .token.keyword,
	.codeblock-light .token.operator,
	.codeblock-light .token.property,
	.codeblock-light .token.string {
		color: highlight;
	}

	.codeblock-light .token.attr-value,
	.codeblock-light .token.url {
		font-weight: normal;
	}
}
`, "",{"version":3,"sources":["webpack://./src/styles/a11y-light.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;;CAEC,cAAc;CACd,mBAAmB;CACnB,sEAAsE;CACtE,gBAAgB;CAChB,gBAAgB;CAChB,oBAAoB;CACpB,kBAAkB;CAClB,iBAAiB;CACjB,mBAAmB;;CAEnB,gBAAgB;CAChB,cAAc;CACd,WAAW;;CAEX,qBAAqB;CACrB,kBAAkB;CAClB,iBAAiB;CACjB,aAAa;AACd;;AAEA,gBAAgB;AAChB;CACC,YAAY;CACZ,SAAS;CACT,cAAc;CACd,oBAAoB;AACrB;;AAEA;;CAEC,mBAAmB;AACpB;;AAEA,gBAAgB;AAChB;CACC,cAAc;CACd,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;;;;CAIC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;;;;;CAKC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;;;;;CAMC,cAAc;AACf;;AAEA;;;;;;CAMC,cAAc;AACf;;AAEA;;;CAGC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,cAAc;AACf;;AAEA;;CAEC,iBAAiB;AAClB;AACA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC;;EAEC,iBAAiB;EACjB,kBAAkB;CACnB;;CAEA;;EAEC,kBAAkB;CACnB;;CAEA;EACC,qBAAqB;EACrB,aAAa;EACb,mBAAmB;CACpB;;CAEA;;;;;;EAMC,iBAAiB;CAClB;;CAEA;;;;;;;;EAQC,gBAAgB;CACjB;;CAEA;;EAEC,mBAAmB;CACpB;AACD","sourcesContent":["/**\n * a11y-light theme for JavaScript, CSS, and HTML\n * Based on the okaidia theme: https://github.com/PrismJS/prism/blob/gh-pages/themes/prism-okaidia.css\n * @author ericwbailey\n */\n\n.codeblock-light code[class*=\"language-\"],\n.codeblock-light pre[class*=\"language-\"] {\n\tcolor: #545454;\n\tbackground: #fbfbfb;\n\tfont-family: Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace;\n\ttext-align: left;\n\twhite-space: pre;\n\tword-spacing: normal;\n\tword-break: normal;\n\tword-wrap: normal;\n\tline-height: 1.65em;\n\n\t-moz-tab-size: 4;\n\t-o-tab-size: 4;\n\ttab-size: 4;\n\n\t-webkit-hyphens: none;\n\t-moz-hyphens: none;\n\t-ms-hyphens: none;\n\thyphens: none;\n}\n\n/* Code blocks */\n.codeblock-light pre[class*=\"language-\"] {\n\tpadding: 1em;\n\tmargin: 0;\n\toverflow: auto;\n\tborder-radius: 0.3em;\n}\n\n.codeblock-light :not(pre) > code[class*=\"language-\"],\n.codeblock-light pre[class*=\"language-\"] {\n\tbackground: #fbfbfb;\n}\n\n/* Inline code */\n.codeblock-light :not(pre) > code[class*=\"language-\"] {\n\tpadding: 0.1em;\n\tborder-radius: 0.3em;\n\twhite-space: normal;\n}\n\n.codeblock-light .token.comment,\n.codeblock-light .token.prolog,\n.codeblock-light .token.doctype,\n.codeblock-light .token.cdata {\n\tcolor: #696969;\n}\n\n.codeblock-light .token.punctuation {\n\tcolor: #545454;\n}\n\n.codeblock-light .token.property,\n.codeblock-light .token.tag,\n.codeblock-light .token.constant,\n.codeblock-light .token.symbol,\n.codeblock-light .token.deleted {\n\tcolor: #007faa;\n}\n\n.codeblock-light .token.boolean,\n.codeblock-light .token.number {\n\tcolor: #008000;\n}\n\n.codeblock-light .token.selector,\n.codeblock-light .token.attr-name,\n.codeblock-light .token.string,\n.codeblock-light .token.char,\n.codeblock-light .token.builtin,\n.codeblock-light .token.inserted {\n\tcolor: #aa5d00;\n}\n\n.codeblock-light .token.operator,\n.codeblock-light .token.entity,\n.codeblock-light .token.url,\n.codeblock-light .language-css .token.string,\n.codeblock-light .style .token.string,\n.codeblock-light .token.variable {\n\tcolor: #008000;\n}\n\n.codeblock-light .token.atrule,\n.codeblock-light .token.attr-value,\n.codeblock-light .token.function {\n\tcolor: #aa5d00;\n}\n\n.codeblock-light .token.keyword {\n\tcolor: #d91e18;\n}\n\n.codeblock-light .token.regex,\n.codeblock-light .token.important {\n\tcolor: #d91e18;\n}\n\n.codeblock-light .token.important,\n.codeblock-light .token.bold {\n\tfont-weight: bold;\n}\n.codeblock-light .token.italic {\n\tfont-style: italic;\n}\n\n.codeblock-light .token.entity {\n\tcursor: help;\n}\n\n@media screen and (-ms-high-contrast: active) {\n\t.codeblock-light code[class*=\"language-\"],\n\t.codeblock-light pre[class*=\"language-\"] {\n\t\tcolor: windowText;\n\t\tbackground: window;\n\t}\n\n\t.codeblock-light :not(pre) > code[class*=\"language-\"],\n\t.codeblock-light pre[class*=\"language-\"] {\n\t\tbackground: window;\n\t}\n\n\t.codeblock-light .token.important {\n\t\tbackground: highlight;\n\t\tcolor: window;\n\t\tfont-weight: normal;\n\t}\n\n\t.codeblock-light .token.atrule,\n\t.codeblock-light .token.attr-value,\n\t.codeblock-light .token.function,\n\t.codeblock-light .token.keyword,\n\t.codeblock-light .token.operator,\n\t.codeblock-light .token.selector {\n\t\tfont-weight: bold;\n\t}\n\n\t.codeblock-light .token.attr-value,\n\t.codeblock-light .token.comment,\n\t.codeblock-light .token.doctype,\n\t.codeblock-light .token.function,\n\t.codeblock-light .token.keyword,\n\t.codeblock-light .token.operator,\n\t.codeblock-light .token.property,\n\t.codeblock-light .token.string {\n\t\tcolor: highlight;\n\t}\n\n\t.codeblock-light .token.attr-value,\n\t.codeblock-light .token.url {\n\t\tfont-weight: normal;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
